
export enum ApiContractImplProtocolCd {
	REST = 'REST'}

